import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-slider-footer',
  templateUrl: './slider-footer.component.html',
  styleUrls: ['./slider-footer.component.scss']
})
export class SliderFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
